"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlanEpochFromUserPrivateMetadata = getPlanEpochFromUserPrivateMetadata;
exports.getPlanVariantFromUserPrivateMetadata = getPlanVariantFromUserPrivateMetadata;
const models_1 = require("@buildwithflux/models");
/**
 * Gets the plan epoch from a user's private metadata, if given
 *
 * @returns undefined iff the UPM was not given
 */
function getPlanEpochFromUserPrivateMetadata(metadata) {
    if (!metadata) {
        return undefined;
    }
    return metadata.creationFlags?.planEpoch ?? models_1.PlanEpoch.enum.legacy;
}
/**
 * Gets the plan variant from a user's private metadata, if given
 *
 * @returns undefined if the UPM was not given or if the plan epoch is such that there is no variant
 */
function getPlanVariantFromUserPrivateMetadata(metadata) {
    if (!metadata) {
        return undefined;
    }
    const epoch = getPlanEpochFromUserPrivateMetadata(metadata);
    if (epoch !== models_1.PlanEpoch.enum.from_202410) {
        return undefined;
    }
    return models_1.PlanVariantForEpochFrom202410.catch(models_1.PlanVariantForEpochFrom202410.enum.from_202410).parse(metadata.creationFlags?.planVariant);
}
//# sourceMappingURL=planEpoch.js.map